import { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { message, Modal } from "antd";
import {
  getAllProducts,
  handleActive,
  selectProducts,
  selectCategories,
  menuCentralAdminThunk,
  disableMenuItemAdminThunk,
  importItemsThunk,
  getSyncStatusThunk
} from "../../redux/slices/products";
import { selectUser } from "../../redux/slices/user";
import ProductsUI from "./components/ProductsUI";

const Products = () => {
  const [loading, handleLoading] = useState(true);
  const products = useSelector(selectProducts);
  const categories = useSelector(selectCategories);
  const dispatch = useDispatch();

  const user = useSelector(selectUser);
  const [visibleEditor, handleVisibleEditor] = useState(false);

  // Sync Global State
  const [isSyncing, setIsSyncing] = useState(false);
  const [lastSyncTime, setLastSyncTime] = useState(null);
  const [syncModalVisible, setSyncModalVisible] = useState(false);
  const [syncOptions, setSyncOptions] = useState({
    categories: false,
    products: false,
    setmenu: false,
    condiments: false,
    sku: ""
  });

  const initialFetch = useCallback(async () => {
    handleLoading(true);

    const response = await dispatch(user.admin ? menuCentralAdminThunk(user.id) : getAllProducts(user.branch));

    if (response.status !== "success") {
      message.error("¡Hubo un problema!");
    }
    handleLoading(false);
  }, [dispatch, user]);

  useEffect(() => {
    initialFetch();
  }, [initialFetch]);

  // Polling para revisar el estado global de la sincronización
  useEffect(() => {
    let interval = null;

    const fetchSyncStatus = async () => {
      const response = await dispatch(getSyncStatusThunk());
      if (response.status === "success" && response.data) {
        setIsSyncing(response.data.isSyncing);
        if (response.data.lastSyncTime) setLastSyncTime(response.data.lastSyncTime);
      }
    };

    fetchSyncStatus(); // llamada inicial
    interval = setInterval(fetchSyncStatus, 10000); // Polling cada 5 segundos

    return () => clearInterval(interval);
  }, [dispatch]);

  const handleProductActive = async (idProduct, val, type, branch, userId) => {
    const response = await dispatch(handleActive(idProduct, val, type, branch, userId));
    if (response.status !== "success") {
      message.error("¡Hubo un problema!");
    }
  };

  const confirmVisibility = (sku, mode, active) => {
    Modal.confirm({
      title: `¿${active ? 'Desactivar' : 'Activar'} para todas las sucursales?`,
      okText: "Si",
      cancelText: "No",
      async onOk() {
        const response = await dispatch(disableMenuItemAdminThunk(user.id, sku, mode))
        console.log(response)
        if (response.status !== "success") {
          message.error("¡Hubo un problema!");
        }
        initialFetch();
      },
      onCancel() {

      },
    });
  }
  const closeEditor = () => {
    handleVisibleEditor(false)
  }
  const openEditor = () => {
    handleVisibleEditor(true)
  }

  const importItems = async () => {
    const response = await dispatch(importItemsThunk())
    console.log(response)
    if (response.status !== "success") {
      message.error("¡Hubo un problema!");
    }
  }

  const handleSyncSubmit = async () => {
    const selectedTypes = [];
    if (syncOptions.categories) selectedTypes.push("categories");
    if (syncOptions.products) selectedTypes.push("products");
    if (syncOptions.setmenu) selectedTypes.push("setmenu");
    if (syncOptions.condiments) selectedTypes.push("condiments");

    const whatsync = selectedTypes.join(",");
    const sku = syncOptions.sku.trim() || undefined;

    if (!whatsync && !sku) {
      message.warning("Debes seleccionar al menos una opción para sincronizar.");
      return;
    }

    setSyncModalVisible(false);
    setIsSyncing(true); // Actualizamos estado local inmediatamente para UX, el polling lo mantendrá
    // Resetear formulario para futuras aperturas
    setSyncOptions({
      categories: false,
      products: false,
      setmenu: false,
      condiments: false,
      sku: ""
    });

    const response = await dispatch(importItemsThunk(whatsync, sku));
    if (response.status !== "success") {
      message.error("¡Hubo un problema al iniciar la sincronización!");
      setIsSyncing(false); // Revertir en caso de error inmediato
    } else {
      message.success("Sincronización iniciada en background.");
    }
  }

  return (
    <ProductsUI
      loading={loading}
      products={products}
      initialFetch={initialFetch}
      handleProductActive={handleProductActive}
      categories={categories}
      confirmVisibility={confirmVisibility}
      visibleEditor={visibleEditor}
      closeEditor={closeEditor}
      openEditor={openEditor}
      importItems={importItems}
      syncModalVisible={syncModalVisible}
      setSyncModalVisible={setSyncModalVisible}
      isSyncing={isSyncing}
      lastSyncTime={lastSyncTime}
      syncOptions={syncOptions}
      setSyncOptions={setSyncOptions}
      handleSyncSubmit={handleSyncSubmit}
    />
  );
};

export default Products;
